module.exports = __webpack_public_path__ + "static/media/link-myndlykill.49ef1cd5.jpg";